import {
    Badge,
    Box,
    Divider,
    FormControl,
    Icon,
    IconButton,
    InputLabel,
    ListItemText,
    MenuItem,
    Select,
    Stack,
    Tab,
    Tabs,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { SyntheticEvent } from "react";
import { useSelector } from "react-redux";
import { HelpIconButton } from "../../../components/exports";
import ItemCount from "../../../components/shared/ItemCount";
import { RootState } from "../../../slices/Store";
import { TodayType } from "../pages/Today";

export default function TodayHeader(props: {
    type: TodayType;
    onChange: (type: TodayType) => void;
    openFilter: () => void;
    totalCount: number;
}) {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));
    const activitiesState = useSelector(
        (state: RootState) => state.activityState
    );

    const handleTypeChange = (event: SyntheticEvent, newValue: TodayType) => {
        props.onChange(newValue);
    };

    return (
        <Box>
            {!isLargeScreen && (
                <Stack>
                    <Stack direction="row" sx={{ mt: 2 }} spacing={1.5}>
                        <FormControl>
                            <InputLabel>نمایش</InputLabel>

                            <Select label="فعالیت" value={props.type}>
                                <MenuItem
                                    onClick={() =>
                                        props.onChange(TodayType.Sales)
                                    }
                                    value={TodayType.Sales}
                                >
                                    فرایند های فروش
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        props.onChange(TodayType.Reminders)
                                    }
                                    value={TodayType.Reminders}
                                    sx={{ pr: 1 }}
                                >
                                    <Badge
                                        color="error"
                                        badgeContent={
                                            activitiesState.reminderNotificationBadgeCount
                                        }
                                    >
                                        <ListItemText>یادآور ها</ListItemText>
                                    </Badge>
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        props.onChange(TodayType.Tasks)
                                    }
                                    value={TodayType.Tasks}
                                    sx={{ pr: 1 }}
                                >
                                    <Badge
                                        color="error"
                                        badgeContent={
                                            activitiesState.taskNotificationBadgeCount
                                        }
                                    >
                                        <ListItemText>وظایف</ListItemText>
                                    </Badge>
                                </MenuItem>

                                <MenuItem
                                    onClick={() =>
                                        props.onChange(TodayType.Notes)
                                    }
                                    value={TodayType.Tasks}
                                    sx={{ pr: 1 }}
                                >
                                    <Badge
                                        color="error"
                                        badgeContent={
                                            activitiesState.taskNotificationBadgeCount
                                        }
                                    >
                                        <ListItemText>نظرات</ListItemText>
                                    </Badge>
                                </MenuItem>
                            </Select>
                        </FormControl>

                        <Box flexGrow={1} />

                        <HelpIconButton tag="sales" />

                        <IconButton size="large" onClick={props.openFilter}>
                            <Icon>tune</Icon>
                        </IconButton>
                    </Stack>

                    <Divider sx={{ mt: 1, mb: 1.5 }} />
                </Stack>
            )}

            {isLargeScreen && (
                <Stack>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Tabs
                            value={props.type}
                            onChange={handleTypeChange}
                            variant="standard"
                        >
                            <Tab
                                value={TodayType.Sales}
                                label="فرایند های فروش"
                            />
                            <Tab
                                value={TodayType.Reminders}
                                label={
                                    <Badge
                                        sx={{ p: 1 }}
                                        badgeContent={
                                            activitiesState.reminderNotificationBadgeCount
                                        }
                                        color="primary"
                                    >
                                        یادآور ها
                                    </Badge>
                                }
                            />
                            <Tab
                                value={TodayType.Tasks}
                                label={
                                    <Badge
                                        sx={{ p: 1 }}
                                        badgeContent={
                                            activitiesState.taskNotificationBadgeCount
                                        }
                                        color="primary"
                                    >
                                        وظایف
                                    </Badge>
                                }
                            />
                            <Tab
                                value={TodayType.Notes}
                                label={
                                    <Badge
                                        sx={{ p: 1 }}
                                        badgeContent={
                                            activitiesState.taskNotificationBadgeCount
                                        }
                                        color="primary"
                                    >
                                        نظرات
                                    </Badge>
                                }
                            />
                        </Tabs>

                        <Box flexGrow={1} />

                        <HelpIconButton tag="sales" />

                        <ItemCount itemCount={props.totalCount} />
                    </Stack>

                    <Divider sx={{ mb: 2 }} />
                </Stack>
            )}
        </Box>
    );
}
